import { createFileRoute } from '@tanstack/react-router';
import { DeviceAlertThresholdsLayout, useGetViewer, UserRole } from '@amber-ui/core';

function DeviceAlertThresholdsRoute() {
  const { bin } = Route.useSearch();
  const { viewer } = useGetViewer();

  if (!bin) return null;

  const role = viewer?.user?.role;
  // Restrictive default: readOnly=true while viewer is loading (role undefined) prevents a brief
  // window where the slider is editable before the role check resolves. ReadOnly and FanAccess
  // users can view thresholds but not modify them — matches the menu visibility decision
  // (informational pages are visible to all roles, edit capability is gated by role).
  const readOnly = !role || role === UserRole.ReadOnly || role === UserRole.FanAccess;

  return <DeviceAlertThresholdsLayout container_id={bin} readOnly={readOnly} viewerRole={role} />;
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/device_alert_thresholds')({
  component: DeviceAlertThresholdsRoute,
});
